import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {POLL_INTERVAL} from '../../constants';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../graphql/common.datatypes';
import {GroupBooking} from '../../graphql/groups.datatypes';
import {gqlGroupBooking} from './getGroupBooking.api';

interface GroupBookingsData {
    groupBookings: {
        data: GroupBooking[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_BILLING_PARTIES_QUERY = gql`
  query groupBookings($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
    groupBookings(count: $count, page: $page, where: $where, orderBy: $orderBy){
      data {
        ${gqlGroupBooking}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getGroupBookings = (count: number, page: number, where?: any, orderBy?: any) => useQuery<GroupBookingsData>(
  GET_BILLING_PARTIES_QUERY,
  {
    variables: {
      count,
      page,
      where,
      orderBy,
    },
    
  }
);

export default getGroupBookings;